import { useLargeFromMediaQuery } from '@madpaws/design-system';
import { Formik } from 'formik';

import { AdvancedSearchForm } from './AdvancedSearchForm/AdvancedSearchForm';
import { searchWidgetValidationSchema, validateSearchWidget } from './utils';

import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

type Props = {
  handleFiltersSave: (searchFilters: SearchFilters) => void;
  searchFilters: SearchFilters;
};

export const MobileSearchWidgetWrapper = ({
  handleFiltersSave,
  searchFilters,
}: Props): ReactElement | null => {
  const isLargeFromViewport = useLargeFromMediaQuery();

  if (isLargeFromViewport) {
    return null;
  }

  return (
    <Formik
      initialValues={searchFilters}
      onSubmit={handleFiltersSave}
      validate={validateSearchWidget}
      validateOnBlur={false}
      validationSchema={searchWidgetValidationSchema}
    >
      <AdvancedSearchForm />
    </Formik>
  );
};
